export default __webpack_public_path__ + "static/api3-fb985f3fe0071b0614aeea4507a68df5.png";